import { Box } from "@mui/material";
import { useBoundDeep } from "@repo/shared/common";
import { BoundDateField, BoundTextField } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React from "react";

import type { ProjectEditProps } from "./ProjectEditProps";
import type { Project } from "../types/ProjectTypes";

export const ProjectIdentification = (props: ProjectEditProps) => {
	const { t } = useTranslation();
	const { project, setProject, errors, setErrors } = props;

	const useBinding = <TValue,>(selector: (m: Project) => TValue) => {
		return useBoundDeep(project, setProject, selector, errors, setErrors);
	};

	const projectNameField = useBinding((p) => p.name);
	const projectNumberField = useBinding((p) => p.number);
	const projectStartDateField = useBinding((p) => p.startDate);
	const projectEndDateField = useBinding((p) => p.endDate);

	return (
		<div>
			<Box className="fullCenter" sx={{ mt: 2.5 }}>
				<BoundTextField
					label={t("name")}
					boundedValue={projectNameField}
					additionalProps={{
						sx: { float: "left", width: "100%" },
						variant: "outlined",
					}}
				/>
			</Box>

			<Box className="fullCenter" sx={{ mt: 2.5 }}>
				<BoundTextField
					label={t("project-number")}
					boundedValue={projectNumberField}
					additionalProps={{
						sx: { float: "left", width: "100%" },
						variant: "outlined",
					}}
				/>
			</Box>

			<Box className="fullCenter" sx={{ mt: 2.5, mb: 2.5 }}>
				<BoundDateField
					additionalProps={{ sx: { width: "45%" } }}
					label={t("from")}
					boundedValue={projectStartDateField}
				/>
				<span className="font50 font2">-</span>
				<BoundDateField
					additionalProps={{ sx: { width: "45%" } }}
					label={t("to")}
					boundedValue={projectEndDateField}
				/>
			</Box>
		</div>
	);
};
